import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useHits } from 'react-instantsearch';

import SearchEmptyState from '../../SearchEmptyState';
import type { SearchForumCategoryPostsHit } from '../types';
import Hit from './Hit';

import './style.scss';

export interface SearchForumCategoryPostsResultsProps {
  uid?: number;
  className?: string;
}

const SearchForumCategoryPostsResults: React.FC<SearchForumCategoryPostsResultsProps> = (props) => {
  const { uid, className } = props;
  const { t } = useTranslation();
  const { hits } = useHits<SearchForumCategoryPostsHit>();

  const classNames = c('SearchForumCategoryPosts__Results', className);

  if (hits.length === 0) {
    return (
      <SearchEmptyState
        title={t('pages.forum.category_posts.empty_state')}
      />
    );
  }

  return (
    <div className={classNames}>
      {hits.map((hit) => (
        <Hit key={hit.post_id[0]} hit={hit} uid={uid} />
      ))}
    </div>
  );
};

export default SearchForumCategoryPostsResults;
